import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: window.location.pathname.split('/')[1] || 'root',
      storage,
      whitelist: []
    },
    reducers
  )

  return persistedReducer
}
